import Vue from 'vue';
import Router from 'vue-router';
import Default from './layouts/Default.vue';
import AuthLayout from './layouts/AuthLayout.vue';

Vue.use(Router);

let authPages = {
    path: '/auth',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/login',
            name: 'login',
            component: () => import('./pages/auth/Login.vue')
        },
        {
            path: '/verify',
            name: 'verify',
            component: () => import('./pages/auth/Verify.vue')
        },
        {
            path: '/upgrade',
            name: 'upgrade',
            component: () => import('./pages/auth/Upgrade.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./pages/auth/Register.vue')
        },
//	{
  //          path: '/raffle',
    //        name: 'raffle',
      //      component: () => import('./pages/auth/Raffle.vue')
       // },
	{
            path: '/payment-link',
            name: 'payment',
            component: () => import('./pages/business/PayApi.vue')
        },
        {
            path: '/password/reset',
            name: 'resetp',
            component: () => import('./pages/auth/ResetPassword.vue')
        },
    ]
};

let zingerPages = {
    path: '/',
    component: Default,
    name: 'Zinger',
    children: [
        {
            path: '/',
            name: 'home',
            component: () => import('./pages/Home.vue')
        },
        {
            path: '/save-qr',
            name: 'qr',
            component: () => import('./pages/transact/QR.vue')
        },
        {
            path: '/transact',
            name: 'send',
            component: () => import('./pages/transact/Send.vue')
        },
        {
            path: '/zings',
            name: 'fandf',
            component: () => import('./pages/transact/Fandf.vue')
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: () => import('./pages/transact/Transactions.vue')
        },
        {
            path: '/bills',
            name: 'bills',
            component: () => import('./pages/transact/Bills.vue')
        },
        {
            path: '/stash',
            name: 'stash',
            component: () => import('./pages/transact/Stash.vue')
        },
        {
            path: '/cards',
            name: 'cards',
            component: () => import('./pages/transact/Cards.vue')
        },
        {
            path: '/customers',
            name: 'customers',
            component: () => import('./pages/business/Customers.vue')
        },
        {
            path: '/signatories',
            name: 'Signatories',
            component: () => import('./pages/business/Signatories.vue')
        },
        {
            path: '/approvals',
            name: 'Approvals',
            component: () => import('./pages/business/Approvals.vue')
        },
        {
            path: '/signatory-approvals',
            name: 'SApprovals',
            component: () => import('./pages/business/SApprovals.vue')
        },
        {
            path: '/customers/:name',
            name: 'customer',
            component: () => import('./pages/business/Customer.vue')
        },
        {
            path: '/staff',
            name: 'staffs',
            component: () => import('./pages/business/Staffs.vue')
        },
        {
            path: '/staff/:name',
            name: 'staff',
            component: () => import('./pages/business/Staff.vue')
        },
        {
            path: '/departments',
            name: 'departments',
            component: () => import('./pages/business/Departments.vue')
        },
        {
            path: '/departments/:name',
            name: 'department',
            component: () => import('./pages/business/Department.vue')
        },
        {
            path: '/save-staff-qr',
            name: 'staffqr',
            component: () => import('./pages/business/QR.vue')
        },
        {
            path: '/transfer',
            name: 'transfer',
            component: () => import('./pages/transact/Withdraw.vue')
        },
        {
            path: '/vouchers',
            name: 'vouchers',
            component: () => import('./pages/transact/Vouchers.vue')
        },
        {
            path: '/support',
            name: 'support',
            component: () => import('./pages/Support.vue')
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('./pages/Profile.vue')
        },
	{
            path: '/pos',
            name: 'pos',
            component: () => import('./pages/business/Pos.vue')
        },
	{
            path: '/bundles',
            name: 'bundles',
            component: () => import('./pages/business/Bundles.vue')
        },
    ]
};

const router = new Router({
    mode: 'history',
    // base: process.env.VUE_APP_BASE_URL,
    linkExactActiveClass: 'is-active',
    routes: [
        authPages,
        zingerPages,
        { path: '*', component: () => import('./pages/Error404.vue') },
    ]
});

export default router;
